import React from "react";
import { Trans } from "@coworker/locales";
import { FixaText } from "../../../shared/wrappers/FixaText/FixaText";
import { SimpleHeader } from "../../../layout/components/SimpleHeader/SimpleHeader";
import FullScreenPopup from "../../../layout/components/FullScreenPopup/FullScreenPopup";
import styles from "./unauthorizedpage.module.css";
import UnauthorizedPageAccordion from "./UnauthorizedPageAccordion";

export const UnauthorizedPage: React.FC = () => (
  <div className={styles["unauthorized-page-wrapper"]}>
    <FullScreenPopup noPadding noAppBar>
      <SimpleHeader displayAllScreens />
      <div className={styles["content-wrapper"]}>
        <div className={styles["header-section"]}>
          <FixaText tagName="h1" textStyle="Heading.L">
            <Trans>unauthorizedTitleString</Trans>
          </FixaText>
          <FixaText
            tagName="p"
            textStyle="Body.M"
            className={styles["header-description"]}
          >
            <Trans>unauthorizedDescriptionString</Trans>
          </FixaText>
        </div>

        <UnauthorizedPageAccordion />
      </div>
    </FullScreenPopup>
  </div>
);
